/* global $ */

class SpMenu {
  constructor() {
    this.isOpen = false;
    this.$container = $('.SpMenu');

    $('.BtnToggleMenu').on('click', () => {
      if (this.isOpen) this.close();
      else this.open();
    });
  }
  open() {
    if (!this.isOpen) {
      this.isOpen = true;
      this.$container.css('display', 'block');
      $('body').addClass('open-sp-menu');
    }
  }
  close() {
    if (this.isOpen) {
      this.isOpen = false;
      this.$container.css('display', 'none');
      $('body').removeClass('open-sp-menu');
    }
  }
}

export default SpMenu;
